import * as React from 'react';
import * as main from "../../main.module.scss";
import * as reg from "./style.module.scss";
import { Modal } from "../../../../Modal";
export const Reg = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={reg.reg}>
      <div className="container">
        <div className={reg.wrap}>
          <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться</button>
          <p style={{fontSize: "17px"}}><strong>Подарок за&nbsp;регистрацию: чек-лист «5&nbsp;шагов, чтобы&nbsp;ребенок учился&nbsp;сам»</strong></p>
          <p>Нажимая, вы принимаете условия соглашения</p>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
